import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HeaderSearch from '../../../../components/headers/catalogs/HeaderSearch';
import HomeLayout from '../../../../layouts/HomeLayout';
import MainLoader from '../../../../components/Loaders/MainLoader';
import Error from '../../../../components/errors/Error';

//SLICE
import { getContractReportThunk, getTransportReportThunk, initialStateReports } from '../../../../store/slices/reportes/reports.slice';
import { FaRegFileExcel } from 'react-icons/fa';
import { generateExcelTransporte } from '../../../../resources/generateExcels';
import { MailCheckIcon, LoaderCircle, MailCheck, DownloadCloudIcon } from "lucide-react";
import { sendReminderContractThunk, initialState } from '../../../../store/slices/public/procesoMatriculacion.slice';
import { downloadArchivosAdjuntos } from '../../../../store/slices/donwloadFile.slice';
import { Select } from 'antd';
import { formatMonthYear } from '../../../../utils/funtions';

const TransportReport = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, error } = useSelector(state => state.reports);
    const { process, message } = useSelector(state => state.proceso_matriculacion);
    const [searchTerm, setSearchTerm] = useState('all');
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        dispatch(getTransportReportThunk('all'));
        return () => {
            dispatch(initialStateReports());
        };
    }, []);

    const handleSearchTerm = () => {
        dispatch(getTransportReportThunk(searchTerm));
    }

    const handleGenerateExcel = () => {
        generateExcelTransporte()
    }


    return (
        <HomeLayout>
            {isLoading || items?.length === 0 ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}

                    <div className='w-full flex justify-end items-center gap-2 p-2 mb-2'>
                        <Select
                            className='w-[50%]'
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e)}
                            options={[
                                { value: 'all', label: 'Todos' },
                                { value: 'Sí', label: 'Si toma transporte' },
                                { value: 'No', label: 'No toma transporte' },
                            ]}
                        />
                        <button
                            onClick={handleSearchTerm}
                            className="flex items-center gap-2 bg-gradient-to-r from-cyan-400 to-blue-500 text-white px-4 py-1 rounded-md shadow-md hover:from-cyan-500 hover:to-blue-600 transition-all duration-300 ease-in-out"
                        >
                            Consultar
                        </button>
                        <button
                            onClick={handleGenerateExcel}
                            className="flex items-center gap-2 bg-gradient-to-r from-green-400 to-green-500 text-white px-4 py-1 rounded-md shadow-md hover:from-green-500 hover:to-green-600 transition-all duration-300 ease-in-out"
                        >
                            <FaRegFileExcel />
                            Exportar Excel
                        </button>
                    </div>
                    <div className="flex flex-col h-[calc(100vh-150px)]">
                        <div className="flex-1 overflow-y-auto rounded-lg">
                            <table className="min-w-full table-zebra table-fixed border-collapse text-[13px] text-left">
                               <thead className="sticky z-10 top-0">
                                    <tr className='text-left h-[50px] bg-p-orange text-white'>
                                        <th className='p-2 '>{t("Cedula")}</th>
                                        <th className='p-2'>{t("Nombre")}</th>
                                        <th className='p-2'>{t("Apellido")}</th>
                                        <th className='p-2'>{t("Curso")}</th>
                                        <th className='p-2'>{t("Toma transporte")}</th>
                                        <th className='p-2'>{t("Fecha contrato")}</th>
                                        <th className='p-2'>{t("Tipo jornada")}</th>
                                        <th className='p-2'>{t("Procesado")}</th>
                                        <th className='p-2'>{t("Fecha procesado")}</th>
                                        <th className='p-2'>{t("Usuario procesado")}</th>
                                        <th className='p-2'>{t("Fecha registro")}</th>
                                        <th className='p-2'>{t("Año lectivo")}</th>
                                        <th className='p-2'>{t("Período")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items?.map((item, index) =>
                                        <tr className='text-left h-[50px]' key={index}>
                                            <td className='p-2'>{item?.ci_estudiante}</td>
                                            <td className='p-2'>{item?.nombre}</td>
                                            <td className='p-2'>{item?.apellido}</td>
                                            <td className='p-2'>{item?.curso}</td>
                                            <td className={`${item?.toma_transporte === 'Sí' ? 'text-green-500' : 'text-red-500'} p-2 font-bold`}>{item?.toma_transporte}</td>
                                            <td className='p-2'>{item?.tipo_jornada}</td>
                                            <td className='p-2'>{formatMonthYear(item?.fecha_contrato)}</td>
                                            <td className='p-2'>{item?.procesado}</td>
                                            <td className='p-2'>{formatMonthYear(item?.fecha_procesado)}</td>
                                            <td className='p-2'>{item?.usuario_procesado}</td>
                                            <td className='p-2'>{formatMonthYear(item?.fecha_registro)}</td>
                                            <td className='p-2'>{item?.anio_lectivo}</td>
                                            <td className='p-2'>{item?.periodo}</td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot className="sticky bottom-0 bg-gray-100 text-gray-700">
                                    <tr>
                                        <td colSpan={13} className="text-right p-2">
                                            Total de registros:{" "}
                                            <span className="text-p-sky text-[18px]">{items?.length ?? 0}</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            )
            }
        </HomeLayout >
    );
};

export default TransportReport;